import Vue from "vue";
import Vuex from "vuex";
import _ from "lodash";
const fb = require("./fbase.js");

Vue.use(Vuex);

// handle page reload if authenticated

fb.auth.onAuthStateChanged(user => {
  if (user) {
    store.commit("setCurrentUser", user);
  }
});

export const store = new Vuex.Store({
  state: {
    about: null,
    user: null,
    authError: null,
    currentUser: null,
    uploads: [],
    include: [""]
  },
  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = val;
    },
    logIn(state, payload) {
      state.user = payload;
    },
    logOut(state) {
      state.currentUser = null;
      state.authError = null;
    },
    authError(state, val) {
      state.authError = val;
    },
    updateUploads(state, payload) {
      state.uploads = payload;
    },
    setTags(state, payload) {
      state.include = payload.include;
    },
    saveText(state, payload) {
      fb.about.doc("content").set({
        html: payload
      });
      state.about = payload.html;
    },
    initText(state, payload) {
      state.about = payload.html;
    },
    addTag(state, payload) {
      if (!state.include.includes(payload)) {
        state.include.unshift(payload);
        fb.settings.doc("include").set({
          include: state.include
        });
      }
    },
    removeTag(state, payload) {
      state.include = state.include.filter(el => {
        return el !== payload;
      });

      fb.settings.doc("include").set({
        include: state.include
      });
    }
  },
  actions: {
    logIn({ commit }, obj) {
      fb.auth
        .signInWithEmailAndPassword(obj.email, obj.password)
        .then(resp => {})
        .catch(err => {
          commit("authError", err);
        });
    },
    setCurrentUser({ commit }, payload) {
      commit("setCurrentUser", payload);
    },
    logOut({ commit }) {
      fb.auth
        .signOut()
        .then(() => {
          commit("logOut");
        })
        .catch(err => {
          commit("authError", err);
        });
    },
    saveText({ commit }, payload) {
      commit("saveText", payload);
    },
    addTag({ commit }, payload) {
      commit("addTag", payload);
    },
    removeTag({ commit, getters }, payload) {
      commit("removeTag", payload);
    },
    setTags({ commit }) {
      console.log("setTags");
      fb.settings.get().then(resp => {
        resp.docs.forEach(doc => {
          if (doc.id == "include") {
            commit("setTags", doc.data());
          }
        });
      });
    },
    setAboutText({ commit }) {
      console.log("setAboutText");
      fb.about
        .doc("content")
        .get()
        .then(doc => {
          commit("initText", doc.data());
        });
    },
    fetchTags({ commit }) {
      console.log("fetchTags");
      return new Promise(resolve => {
        fb.settings.get().then(resp => {
          resp.docs.forEach(doc => {
            if (doc.id == "include") {
              commit("setTags", doc.data());
              resolve();
            }
          });
        });
      });
    },
    fetchUploads({ commit, dispatch }) {
      console.log("fetchUploads");
      return new Promise(resolve => {
        fb.uploads.get().then(resp => {
          let items = [];
          resp.docs.forEach(doc => {
            items.push({ ...doc.data(), id: doc.id });
          });
          commit("updateUploads", items);
          resolve();
        });
      });
    },

    deleteItem({ commit, dispatch }, payload) {
      let loc = unescape(payload.url).split("?")[0];
      let img = loc.substr(loc.lastIndexOf("/o/") + 3, loc.lastIndexOf("."));
      let dbRef = fb.uploads.doc(payload.id);
      let imgRef = fb.storage.ref(img);
      dbRef.delete().then(() => {
        dispatch("fetchUploads").then(() => {
          imgRef.delete().then(() => {
            console.log("Delete Complete!");
          });
        });
      });
    },
    updateAsset({ commit, dispatch }, payload) {
      let dbRef = fb.uploads.doc(payload.id);
      let tags = payload.tags.replace(/,\s*$/, "");
      dbRef
        .update({
          name: payload.name,
          tags: tags
        })
        .then(function() {
          dispatch("fetchUploads");
          console.log("Document successfully updated!");
        });
    },
    saveUploadRef({ dispatch }, { storageRef, uploadInfo, path }) {
      storageRef
        .child(path)
        .getDownloadURL()
        .then(url => {
          fb.uploads
            .add({ url, ...uploadInfo })
            .then(() => {
              dispatch("fetchUploads").then(() => {
                console.log("STORE: Upload Complete!");
              });
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(err => {
          console.log(err);
        });
    },
    uploadImage(
      { dispatch, getters },
      { filename, filetitle, image, tags, width, height }
    ) {
      const ext = filename.slice(filename.lastIndexOf("."));
      let timestamp = Date.now();
      let ref = fb.storage.ref(`images/img-upload-${timestamp}${ext}`);
      let storageRef = fb.storage.ref();
      let uploadInfo = {
        name: filetitle,
        filename: filename,
        uploaded: timestamp,
        tags: tags.toLowerCase(),
        width: width,
        height: height
      };

      // Upload Image
      ref.put(image).then(fileData => {
        let path = fileData.metadata.fullPath;
        dispatch("saveUploadRef", { storageRef, uploadInfo, path });
      });
    }
  },
  getters: {
    aboutText(state) {
      return state.about;
    },
    uploads(state) {
      return state.uploads.sort((a, b) => {
        return b.uploaded - a.uploaded;
      });
    },
    filteredUploads(state) {
      return state.uploads.filter(el => {
        let found = false;
        let elTags = el.tags.split(",");
        elTags.forEach(item => {
          let tag = item.trim();
          if (state.include.includes(tag)) {
            found = el;
          }
        });
        return found;
      });
    },
    isLoggedIn(state) {
      return state.currentUser !== null;
    },
    authError(state) {
      return state.authError;
    },
    getCurrentUser(state) {
      return state.currentUser;
    },
    tagState(state) {
      return tag => {
        return state.include.includes(tag);
      };
    },
    includesTag: state => tag => {
      return state.include.includes(tag);
    },
    tags(state) {
      let tags = [];
      state.uploads.forEach(el => {
        let elTags = el.tags.split(",");
        elTags.forEach(tag => {
          let itag = tag.toLowerCase().trim();
          tags.push(itag);
        });
      });
      return _.uniq(tags);
    },
    filteredTags(state) {
      let tags = [];
      state.uploads.forEach(el => {
        let elTags = el.tags.split(",");
        elTags.forEach(tag => {
          let itag = tag.toLowerCase().trim();
          if (state.include.includes(itag)) {
            tags.push(itag);
          }
        });
      });
      return _.uniq(tags);
    }
  }
});
